import React, { useRef, useState } from 'react';
import { TableDataState, usePaginatedQueryV8 } from 'motion-components';
import { Card } from 'react-bootstrap';
import { useApolloClient } from '@apollo/client';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlGetPendingReceptionQuery } from '../graphql';
import { buildWhereFromFilterValues, Filters } from './filters';
import { DataGrid } from './grid';
import { handleExport } from './export-columns';

/** Λίστα εντύπων προς παραλαβή από σημείο παραλαβής αποβλήτων */
export const Idocs4WasteReceptionGridPage = observer(() => {
  const { appStore, tableStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('Idocs4WasteReceptionGridPage');
  const location = useLocation<any>();
  const history = useHistory();
  const [selected, setSelected] = useState<any>(null);
  const { t } = useTranslation();
  const gridRef = useRef();

  const initOrderBy = 'dateCollected DESC';
  const query = usePaginatedQueryV8(
    gqlGetPendingReceptionQuery,
    buildWhereFromFilterValues,
    location.state?.order ?? initOrderBy,
    appStore,
    true,
    {},
    true,
  );

  const {
    loading,
    data,
    dataCount,
    error,
    initPageIndex,
    filtersChanged,
    gridPageChanged,
    queryState,
    queryParams,
    setQueryParams,
    refetch,
  } = query;

  const client = useApolloClient();
  const filterValues = queryState?.filterValues ?? {};

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  }

  return (
    <Card className="shadow">
      <Card.Header>
        <Card.Title className="m-0">{t('Έντυπα Αναγνώρισης προς Παραλαβή')}</Card.Title>
      </Card.Header>
      <Card.Body className="nopadding">
        <Filters
          onChange={filtersChanged}
          initialValues={filterValues}
          disable={tableStore.state !== TableDataState.browse}
        />
        <DataGrid
          ref={gridRef}
          loading={loading}
          data={data}
          dataCount={dataCount}
          initPageIndex={initPageIndex}
          onPageChange={gridPageChanged}
          handleExport={() => handleExport(client, queryState, t)}
          initOrderBy={queryParams?.order ?? initOrderBy}
          onOrderChange={(orderBy) => {
            const newQueryParams = { ...queryParams, order: orderBy };
            setQueryParams(newQueryParams);
            history.replace({
              pathname: location.pathname,
              state: {
                ...location.state,
                order: orderBy,
              },
            });
          }}
          selected={selected}
          setSelected={setSelected}
          refetch={refetch}
          defaultReceptionDate={
            filterValues.defaultReceptionDate
              ? new Date(filterValues.defaultReceptionDate)
              : new Date()
          }
          useCustomReceptionDate={filterValues.useCustomReceptionDate ?? true}
        />
      </Card.Body>
    </Card>
  );
});
